import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { pageConfigurationActions } from '@/store/PageConfiguration/PageConfigurationSagas'
import {
  selectPageConfigurationData,
  selectPageConfigurationIsInitialized,
  selectPageConfigurationIsLoading,
} from '@/store/PageConfiguration/PageConfigurationSelectors'
import { mapCommonSubscriptionData } from './Common/mapCommonSubscriptionData'
import { mapTelecomSubscriptionData } from './Telecom/mapTelecomSubscriptionData'
import { mapEnergySubscriptionData } from './Energy/mapEnergySubscriptionData'
import { initializeContractData } from '../SubscriptionFormSlice'
import { initialFormConfigurationStateUpdate } from '../SubscriptionFormConfigurationSlice'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { mapInsuranceSubscriptionData } from './Insurance/mapInsuranceSubscriptionData'

const useSubscriptionForm = ({ initUrl, id }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { authTokenSession: token } = useSelector(selectAuthData)
  const elements = useSelector(selectPageConfigurationData)
  const isInitialized = useSelector(selectPageConfigurationIsInitialized)
  const pageConfigurationIsLoading = useSelector(selectPageConfigurationIsLoading)

  useEffect(() => {
    dispatch({ type: pageConfigurationActions.INITIALIZE, initUrl: initUrl?.replace('*', id) + '?isSpa=1' })
  }, [])

  useEffect(() => {
    if (!isInitialized || pageConfigurationIsLoading || !elements) return
    const contractData = {
      common: mapCommonSubscriptionData(elements),
      telecom: mapTelecomSubscriptionData(elements),
      energy: mapEnergySubscriptionData(elements),
      insurance: mapInsuranceSubscriptionData(elements),
    }
    dispatch(initializeContractData(contractData))
  }, [elements])

  useEffect(() => {
    if (!elements || !isInitialized || pageConfigurationIsLoading) return
    dispatch(
      initialFormConfigurationStateUpdate({
        token,
        id,
        isEditable: false,
        lastSentDate: elements.lastSentDate,
        realStatus: elements.realStatus,
        subscriptionStatus: elements.displayLightStatus ?? '',
        isRetracted: elements.is_retracted,
        statusErrors: elements.status_errors ?? [],
        createdByUserId: elements.created_by_user_id?.toString() ?? '',
      }),
    )
  }, [elements, isInitialized, pageConfigurationIsLoading])

  return { t }
}

export default useSubscriptionForm
